const FirmwareUpdateFailureToast = () => {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center',
            justifyContent: 'flex-start', 
            backgroundColor: '#FFF4E5',
            borderRadius: '4px !important',
            width: '100%',
        }}>
            <div style={{ textAlign: 'left' }}> 
                <strong style={{ 
                    fontSize: '16px', 
                    color: '#CE0E0E',
                    fontFamily: 'Jost'
                }}>Upload Failure</strong>
                <p style={{ 
                    fontSize: '14px', 
                    color: '#CE0E0E',
                    fontFamily: 'Jost'
                }}>Firmware update failed. Please clear the uploaded file, check if the device is connected properly and try again.</p>
            </div>
        </div>
    );
};

export default FirmwareUpdateFailureToast;
